module.exports = __webpack_public_path__ + "img/logo.ba1066a9.svg";